import { jsx as _jsx } from "react/jsx-runtime";
const Card = ({ children }) => {
    return (_jsx("div", { className: "flex flex-col p-6 gap-1 rounded-2xl border border-card mb-30 bg-white", children: children }));
};
export default Card;
//# sourceMappingURL=Card.js.map